import { daysRange } from 'app/constants/dates';

import { DataTransferAdminState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const dataTransferAdminState: DataTransferAdminState = {
  dataTransferLogs: [],
  totalRecordCount: 0,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  search: '',
  fromDate: daysRange.minDay.toISODate() as string,
  toDate: daysRange.maxDay.toISODate() as string,
};
